// Import necessary GSAP plugins and Lenis for smooth scrolling
gsap.registerPlugin(Observer, ScrollTrigger, ScrollToPlugin);
// Initialize a new Lenis instance for smooth scrolling
const lenis = new Lenis();

// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
lenis.on("scroll", ScrollTrigger.update);

// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
// This ensures Lenis's smooth scroll animation updates on each GSAP tick
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
gsap.ticker.lagSmoothing(0);

// Media Query
function isMobile() {
  return window.matchMedia("(max-width: 767px)").matches;
}

function initFalseTransition() {
  const event = new Event("webfontloaded");
  const loadingScreen = document.querySelector(".loading-screen");
  const interval = 200;
  let try_count = 0;
  let is_initial = true;
  const max_try = 10; // 最大試行回数
  if (loadingScreen) {
    function hideScreen() {
      // loadingScreen.classList.remove("is-transition");
      loadingScreen.classList.add("hide-screen");
      if (!is_initial) {
        // 処理の重複を避けるため、初回以外にイベントを発火
        document.dispatchEvent(event);
      } else {
        is_initial = false;
      }
    }

    function checkFontLoaded() {
      try {
        if (!FONTPLUS.isloading() || try_count >= max_try) {
          // triggerForceRecalcPosition();
          hideScreen();
          onFontLoad();
        } else {
          // console.log(try_count++);
          try_count++;
          setTimeout(checkFontLoaded, interval);
        }
      } catch (e) {
        try_count++;
        if (try_count < max_try) {
          setTimeout(checkFontLoaded, interval);
        } else {
          hideScreen();
        }
      }
    }
    setTimeout(checkFontLoaded, interval);
  }
}

// ドロワーメニュー
function initDrawerMenu() {
  const menuContainer = document.querySelector(".main-navigation");
  let menuBtns = document.querySelectorAll(".main-control__menu");
  const body = document.body;
  if (!menuBtns || menuContainer.classList.contains("drawer-menu-initialized"))
    return;
  let isOpen = false;
  const menu_elements = menuContainer.querySelectorAll(
    ".main-navigation__main li, .main-navigation__sub li, .main-navigation__ec-categories li, .main-navigation__ec-buttons li, .main-navigation__switch"
  );

  function openMenu() {
    body.classList.add("drawer-menu-open");
    menuBtns.forEach((btn) => {
      btn.querySelector(".text").innerText = "CLOSE";
    });
    isOpen = true;
    gsap.fromTo(
      menu_elements,
      {
        opacity: 0,
        filter: "blur(2px)",
        y: (index) => {
          // console.log(index);
          return 10 + (20 - index) * 0.5;
        },
      },
      {
        stagger: {
          from: "end",
          amount: 0.3,
        },
        duration: (index) => {
          return 0.3 + (20 - index) * 0.03;
        },
        opacity: 1,
        filter: "blur(0px)",
        y: 0,
        ease: "power2.out",
      }
    );
  }

  function closeMenu() {
    body.classList.remove("drawer-menu-open");
    menuBtns.forEach((btn) => {
      btn.querySelector(".text").innerText = "OPEN";
    });
    isOpen = false;
    gsap.to(menu_elements, {
      duration: 0.6,
      opacity: 0,
      filter: "blur(2px)",
      y: -10,
      ease: "power2.in",
    });
  }

  function toggleMenu() {
    console.log('toggle Menu!');
    
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  function initMenuButton() {
    menuBtns = document.querySelectorAll(".main-control__menu");
    menuBtns.forEach((btn) => {
      btn.removeEventListener("click", toggleMenu);
      btn.addEventListener("click", toggleMenu);
    });

    const simplePageHeaderMenu = document.querySelector(
      ".simple-page-header .main-control__menu"
    );
    const mainControlMenu = document.querySelector(
      ".main-control .main-control__menu"
    );

    if (simplePageHeaderMenu && mainControlMenu && !isMobile()) {
      mainControlMenu.classList.add("hide-temporally");

      // IntersectionObserverで.simple-page-header .main-control__menuの可視性を監視
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // 画面内に見えている場合は非表示
              mainControlMenu.classList.add("hide-temporally");
            } else {
              // 画面外に出た場合は再表示
              mainControlMenu.classList.remove("hide-temporally");
            }
          });
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0,
        }
      );

      observer.observe(simplePageHeaderMenu);

      // ページ遷移時にObserverをクリーンアップ
      document.addEventListener(
        "swup:animation:out:start",
        () => {
          observer.disconnect();
        },
        { once: true }
      );
    } else if (mainControlMenu) {
      mainControlMenu.classList.remove("hide-temporally");
    }
  }
  initMenuButton();

  // Swupイベントでメニューを閉じる
  const closeMenuOnSwupEvents = [
    "swup:animation:out:start",
    "swup:link:self",
    "swup:link:anchor",
  ];
  closeMenuOnSwupEvents.forEach((eventName) => {
    document.addEventListener(eventName, () => {
      if (isOpen) {
        closeMenu();
      }
    });
  });

  // メニュー外クリックで閉じる
  document.body.addEventListener("click", (e) => {
    if (
      !e.target.closest(".main-navigation__content") &&
      !e.target.closest(".main-control__menu") &&
      isOpen
    ) {
      closeMenu();
    }
  });

  // 初期化済みクラス
  menuContainer.classList.add("drawer-menu-initialized");
  document.addEventListener("swup:page:view", initMenuButton);
}

// UIの色反転
function initChangeUIDisplay() {
  const topUI = document.querySelector(".main-control__top");
  const minUI = document.querySelector(".main-control__menu");
  const bottomUI = document.querySelector(".main-control__bottom");

  let topUI_addtional_parts = document.querySelectorAll(".follow-ui-color");

  if (!topUI || topUI.classList.contains("invert-control-initialized")) return;

  let changeColorPositions = [];
  let hideElementPositions = [];

  function getPositions() {
    const invertSections = document.querySelectorAll(".invert-ui-color");
    const hideSections = document.querySelectorAll(".hide-ui-elements");
    changeColorPositions = [];
    hideElementPositions = [];
    if (invertSections.length !== 0) {
      invertSections.forEach((section) => {
        // スクロール位置を計算しpositions配列に追加
        const rect = section.getBoundingClientRect();
        const scrollTop = lenis.animatedScroll;
        const offsetTop = rect.top + scrollTop;
        changeColorPositions.push({
          start: offsetTop,
          end: offsetTop + section.offsetHeight,
        });
      });
    }
    if (hideSections.length !== 0) {
      hideSections.forEach((section) => {
        // スクロール位置を計算しpositions配列に追加
        const rect = section.getBoundingClientRect();
        const scrollTop = lenis.animatedScroll;
        const offsetTop = rect.top + scrollTop;
        hideElementPositions.push({
          start: offsetTop,
          end: offsetTop + section.offsetHeight,
        });
      });
    }
  }

  function collectAdditionalParts() {
    topUI_addtional_parts = document.querySelectorAll(".follow-ui-color");
  }

  function checkPosition() {
    const scrollPos = isMobile()
      ? lenis.animatedScroll + window.innerHeight * 0.04
      : lenis.animatedScroll + window.innerHeight * 0.1;
    const scrollPosMid = isMobile()
      ? lenis.animatedScroll + window.innerHeight * 0.5
      : lenis.animatedScroll + window.innerHeight * 0.5;
    const scrollPosBottom = isMobile()
      ? lenis.animatedScroll + window.innerHeight * 0.96
      : lenis.animatedScroll + window.innerHeight * 0.9;
    const isSimpleUIPage = document.querySelector(
      ".simple-page-header .main-control__menu"
    )
      ? true
      : false;
    let isInInvertTop = false;
    let isInInvertMid = false;
    let isInInvertBottom = false;
    let isInHideTop = false;
    let isInHideMid = false;
    let isInHideBottom = false;

    // 色変え区間にいるかチェック
    for (let i = 0; i < changeColorPositions.length; i++) {
      if (
        scrollPos >= changeColorPositions[i].start &&
        scrollPos <= changeColorPositions[i].end
      ) {
        isInInvertTop = true;
      }
      if (
        scrollPosMid >= changeColorPositions[i].start &&
        scrollPosMid <= changeColorPositions[i].end
      ) {
        isInInvertMid = true;
      }
      if (
        scrollPosBottom >= changeColorPositions[i].start &&
        scrollPosBottom <= changeColorPositions[i].end
      ) {
        isInInvertBottom = true;
      }
    }
    if (isInInvertTop) {
      topUI.classList.add("invert-color");
      if (topUI_addtional_parts.length > 0) {
        topUI_addtional_parts.forEach((part) => {
          part.classList.add("invert-color");
        });
      }
    } else {
      topUI.classList.remove("invert-color");
      if (topUI_addtional_parts.length > 0) {
        topUI_addtional_parts.forEach((part) => {
          part.classList.remove("invert-color");
        });
      }
    }
    if (isInInvertMid) {
      minUI.classList.add("invert-color");
    } else {
      minUI.classList.remove("invert-color");
    }
    if(bottomUI){
      if (isInInvertBottom) {
        bottomUI.classList.add("invert-color");
      } else {
        bottomUI.classList.remove("invert-color");
      }
    }

    // 隠し区間にいるかチェック
    if (!isSimpleUIPage) {
      for (let i = 0; i < hideElementPositions.length; i++) {
        if (
          scrollPos >= hideElementPositions[i].start &&
          scrollPos <= hideElementPositions[i].end
        ) {
          isInHideTop = true;
        }
        if (
          scrollPosMid >= hideElementPositions[i].start &&
          scrollPosMid <= hideElementPositions[i].end
        ) {
          isInHideMid = true;
        }
        if (
          scrollPosBottom >= hideElementPositions[i].start &&
          scrollPosBottom <= hideElementPositions[i].end
        ) {
          isInHideBottom = true;
        }
      }
      if (isInHideTop) {
        topUI.classList.add("hide-temporally");
        if (topUI_addtional_parts.length > 0) {
          topUI_addtional_parts.forEach((part) => {
            part.classList.add("hide-temporally");
          });
        }
      } else {
        topUI.classList.remove("hide-temporally");
        if (topUI_addtional_parts.length > 0) {
          topUI_addtional_parts.forEach((part) => {
            part.classList.remove("hide-temporally");
          });
        }
      }
      if (isInHideMid) {
        minUI.classList.add("hide-temporally");
      } else {
        minUI.classList.remove("hide-temporally");
      }
      if(bottomUI){
        if (isInHideBottom) {
          bottomUI.classList.add("hide-temporally");
        } else {
          bottomUI.classList.remove("hide-temporally");
        }
      }
    }
  }

  window.removeEventListener("resize", getPositions);
  window.addEventListener("resize", getPositions);

  // Custom event to force recalculation
  window.removeEventListener("force-recalc-position", getPositions);
  window.addEventListener("force-recalc-position", getPositions);

  // Swup event to force recalculation
  document.removeEventListener("swup:page:view", getPositions);
  document.addEventListener("swup:page:view", getPositions);

  document.removeEventListener("swup:page:view", collectAdditionalParts);
  document.addEventListener("swup:page:view", collectAdditionalParts);

  getPositions();
  gsap.ticker.add(checkPosition);

  // 初期化完了のフラグ
  topUI.classList.add("invert-control-initialized");
}

// Topへ戻る
function scrollToTop(){
  // トップへスクロール
  lenis.stop();
  gsap.to(window, {
    scrollTo: 0,
    duration: 2,
    ease: "power2.inOut",
    onComplete: () => {
      // history.pushState(null, "", hash);
      lenis.start();
    },
  });
}
function initScrollToTop() {
  const to_top_buttons = document.querySelectorAll('a[href="#top"]');
  if (to_top_buttons.length === 0) return;
  to_top_buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      scrollToTop();
    });
  });
}

function onFontLoad() {
  if (typeof window._showLogoLeaves === "function") {
    window._showLogoLeaves();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initFalseTransition();
  initDrawerMenu();
  initChangeUIDisplay();
  initScrollToTop();
});
